var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-900"},[(_vm.isModelSet)?_c('model-view'):_c('upload-page'),_vm._v("> ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }